<template>
    <div :class="[$style.__content]" >
        <Banner></Banner>
        <div v-if="sendSuccessMessage == false">
            <div :class="[$style.__main]" >
                <div v-if="!checkAgentOnline">
                    <div v-if="sso != null">
                        <SendMessageOffline :clearErrorLog="clearErrorLog"></SendMessageOffline>
                    </div>
                    <div v-else>
                        <RegisterOffline :nameMemory="nameMemory" :isClose="isClose"></RegisterOffline>
                    </div>
                </div>
                <div v-else>
                    <RegisterOnline></RegisterOnline>
                </div>
            </div>
        </div>
        <div v-else>
            <div :class="[$style.__success__container]">
                <img :src="icon.success" width="20"> <h4> {{$t('notification.success')}}</h4>
                <hr>
                <p>{{$t('notification.messages', {gender : gender, name : name})}}</p>
                <button :class="['btn', 'btn-success', $style.__submit]" @click="rollbackSendMessage">{{$t('button.messages_new')}}</button>
            </div>
        </div>
        <Loading :displayLoading.sync="displayLoading"></Loading>
    </div>
</template>

<script>
import RegisterOnline from '../pages/RegisterOnline';
import RegisterOffline from '../pages/RegisterOffline';
import Banner from '../blocks/Banner';
import Chathub from '@/apis/chathub';
import Socket from '@/sockets/Socket';
import SendMessageOffline from '../pages/SendMessageOffline';
import Loading from '../blocks/Loading'

let chathubObject = new Chathub;

export default {
    props : {
        isClose : {
            type : Boolean
        },
        clearErrorList : {
            type : Boolean
        }
    },
    data () {
        return {
            registerResponse : [],
            resultCreateRoom : false,
            checkAgentOnline : '',
            nameMemory : '',
            sso : [],
            clearErrorLog : false,
            displayLoading : false,
            sendSuccessMessage : false,
            icon : {
                success : process.env.NODE_ENV == 'local' ? require('@/medias/images/icon/success-icon-10.png') : process.env.VUE_APP_STORAGE + '/vue/img/icon/success-icon-10.png'
            },
            gender : '',
            name : '',
            agentStatus : false
        }
    },
    watch: { 
        clearErrorList: function(newVal, oldVal) { // watch it
            this.clearErrorLog = true
        }
    },
    components : {
        RegisterOnline, Banner, RegisterOffline, SendMessageOffline, Loading
    },
    methods : {
        initChat : function (name, email, gender = "1", contract = '') {

            var registerUser         = chathubObject.registerUser(name, email);

            var client_cookie        = [];
            var resultCreateRoom    = registerUser.then(response => {
                if (response.success == true && response.newRoom == true) {
                    client_cookie   = {
                        token : response.room.v.token,
                        room : response.room._id,
                        gender : gender,
                        name : name,
                        contract : contract
                    }
                    var setGender       = chathubObject.setGender(response.room.v.token, gender)
                    var setContract     = chathubObject.setContract(response.room.v.token, contract)
                    var initCookie      = new Promise(function (resolve, reject) {
                        $cookies.set('fpt_livechat', client_cookie);
                        $cookies.set('fpt_gender', gender);
                        resolve('Success!');
                    });
                    var that = this;
                    initCookie
                    .then(function (success) {

                        that.$router.replace('/chat');
                    })
                   
                } else {
                    this.nameMemory = name;
                    this.$emit('statusOnlineUpdated', false)
                    this.$store.dispatch('changeStatus', false)
                    this.checkAgentOnline = false;

                    return false;
                }
            });


        },
        initChatOffline : function (name, email, gender, msg = '') {
           
            var registerUser         = chathubObject.registerUserOffline(name, email);

            var client_cookie        = [];
            var resultCreateRoom    = registerUser.then(response => {
                if (response.data.success == true) {
                    var that = this;
                    $cookies.set('fpt_livechat_offline', true)
                    that.$router.replace({path: '/chat', query : { type: "offline", email : email, name : name, msg : msg}});
                } else {
                    this.$store.dispatch('changeStatus', false)
                    return false;
                }
            });


        },

        initChatOfflineV2 : function (name, email, gender, msg = '', originName = '') {
            this.displayLoading     = true;
            var registerUser        = chathubObject.registerUserOffline(name, email);
            var client_cookie       = [];
            var resultCreateRoom    = registerUser.then(response => {
                if (response.data.success == true) {
                    this.displayLoading = false;
                    this.sendMessageOffline(name, email, gender, msg);
                    if (originName != '') {
                        this.name = originName;
                    } else {
                        this.name = name;
                    }
                    if (this.sso) {
                        this.gender = this.$t("messages.gender");
                    } else {
                        if (gender == 1) {
                            this.gender = this.$t("messages.mr");
                        } else {
                            this.gender = this.$t("messages.ms");
                        }
                    }
                } else {
                    this.$store.dispatch('changeStatus', false)
                    this.displayLoading = false;
                    return false;
                }
            }).catch(error => {
                this.displayLoading = false;
            });
        },

        sendMessageOffline : function (name, email, gender, message) {

            if (message.trim().length > 0) {

                var resultSendMessage = chathubObject.sendOfflineMessage(name, email, message);
                resultSendMessage.then(response => {
                    if  (response.data.success) {
                        this.sendSuccessMessage = true;
                    }

                }).catch(error => {
                  
                })
                this.msg = '';
            }
        },

        checkCookie : function (checkOnline) {
            var sso = this.$cookies.get("fpt_sso");
            if(sso && sso.name.length > 0) {
                if(!checkOnline) {
                    // this.initChatOffline(sso.name, sso.email, sso.gender);
                } else {

                    if (!this.$cookies.isKey('fpt_livechat') && localStorage.getItem("closeChat") == 'false') {
                        sso.name = sso.name.split('+').join(' ');
                        this.initChat(sso.name, sso.email, sso.gender, sso.contract);
                    }
                }
            } 
            var token = null;
            var room = null;

            if (this.$cookies.isKey('fpt_livechat')) {
                token = this.$cookies.get("fpt_livechat").token;
                room = this.$cookies.get("fpt_livechat").room;
            } 

            if (token != null && room != null) {
                this.$router.replace('/chat');
            }
        },
        rollbackSendMessage : function () {
            this.sendSuccessMessage = false;
        },
        showChat : function () {
            var sso = this.$cookies.get("fpt_sso");
            if(sso && sso.name.length > 0) {
                if(!this.agentStatus) {
                    console.log('false')
                    // this.initChatOffline(sso.name, sso.email, sso.gender);
                } else {
                    if (!this.$cookies.isKey('fpt_livechat')) {
                        sso.name = sso.name.split('+').join(' ');
                        this.initChat(sso.name, sso.email, sso.gender, sso.contract);
                    }
                }
            } 

        }
    },

    created ()  {
        this.sso                = this.$cookies.get("fpt_sso");
        var chathub             = chathubObject.setToken();
        chathub.then(response => {
            this.checkAgentOnline = response.data.config.online;
            this.checkCookie(response.data.config.online)
            this.agentStatus = response.data.config.online;

        })
        .catch(error => {
            this.checkAgentOnline = false
            this.checkCookie(false);
            this.agentStatus = false;
        })

    },
    mounted () {
        if(document.querySelectorAll('[livechat-show="true"]')[0]) {
            document.querySelectorAll('[livechat-show="true"]')[0].addEventListener("click", this.showChat);
        }
    }
    
}
</script>

<style scoped module lang="scss">
    .__content {
        width:100%;
        .__main {
            padding: 15px 15px;
            min-height: 225px;
            position: relative;
        }
    }
    .__content__off {
        display:none;
    }
    .__success__container {
        padding : 40px 10px;
        padding-top: 30px;
        text-align: center;
        h4 {
            font-size: 15px;
            font-weight: 600;
            display: inline;
            text-transform: uppercase;
            top: 2px;
            position: relative;
        }
        p {
            font-size: 14px;
            margin-top: 15px !important;
        }
        .__submit {
            padding : 5px 15px !important;
            font-size: 14px !important;
            text-transform: uppercase !important;
            margin-top: 10px !important;
        }
    }
</style>